import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { ESN_ICONS, type EsnIconName } from '../../../shared/icons';

/**
 * One glyph from the Figma system icon set, drawn in the current text colour.
 */
@Component({
  selector: 'esn-icon',
  templateUrl: './icon.component.html',
  styles: [':host { display: inline-flex; flex-shrink: 0; line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { 'aria-hidden': 'true' },
})
export class IconComponent {
  readonly name = input.required<EsnIconName>();

  /**
   * Rendered edge length in px; defaults to the icon's own Figma size.
   */
  readonly size = input<number | null>(null);

  private readonly sanitizer = inject(DomSanitizer);

  protected readonly def = computed(() => ESN_ICONS[this.name()]);
  protected readonly px = computed(() => this.size() ?? Number(this.def().viewBox.split(' ')[2]));
  protected readonly body = computed(() => this.sanitizer.bypassSecurityTrustHtml(this.def().body));
}
